import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenerateReportComponent } from './generate-report.component';
import { ButtonModule, DropdownModule, MultiSelectModule } from "@xref/xref-lib";
import {
  DateRangePickerPopoverV2Module
} from "../../lib/app-date-range-picker-popover-v2/date-range-picker-popover-v2.module";
import { InsightsFilterModalModule } from '../insights-filter-modal/insights-filter-modal.module';
import { LoaderModule } from "../loader/loader.module";

@NgModule({
  declarations: [GenerateReportComponent],
  imports: [
    CommonModule,
    ButtonModule,
    DropdownModule,
    MultiSelectModule,
    DateRangePickerPopoverV2Module,
    InsightsFilterModalModule,
    LoaderModule,
  ],
  exports: [GenerateReportComponent]
})
export class GenerateReportModule { }

